export type PasswordRequirementId =
  | 'minLength'
  | 'uppercase'
  | 'lowercase'
  | 'number'
  | 'special'

export type PasswordRequirement = {
  id: PasswordRequirementId
  label: string
  test: (password: string) => boolean
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: 'minLength',
    label: 'Mínimo de 8 caracteres',
    test: (password) => password.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'Letra maiúscula',
    test: (password) => /[A-ZÀ-Ý]/.test(password),
  },
  {
    id: 'lowercase',
    label: 'Letra minúscula',
    test: (password) => /[a-zà-ÿ]/.test(password),
  },
  {
    id: 'number',
    label: 'Número',
    test: (password) => /\d/.test(password),
  },
  {
    id: 'special',
    label: 'Caractere especial',
    test: (password) => /[^A-Za-zÀ-ÿ0-9]/.test(password),
  },
]

export function getPasswordRequirementStatus(password: string) {
  return PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    met: requirement.test(password),
  }))
}

export function passwordMeetsAllRequirements(password: string): boolean {
  return PASSWORD_REQUIREMENTS.every((requirement) => requirement.test(password))
}
